import vue from 'vue';
import { default as Component } from 'vue-class-component';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';

import User from '../../../interfaces/User';
import Auth from '../../../interfaces/Auth';

@Component({
  template: require('./login-page.html'),
})
export class LoginPage extends vue {
  email = '';
  password = '';
  error = '';
  errors = [];
  loadingStatus = true;
  user = IocContainer.get < User > (SERVICES.USER);
  auth = IocContainer.get < Auth > (SERVICES.AUTH);

  mounted() {
    if (this.auth.isAuthenticated()) {
      this.$router.push({ name: 'course' });
    }
  }
  get loading() {
    return this.loadingStatus;
  }

  login() { 
    this.auth.login(this.email, this.password.trim()).then(
      (response) => {
        this.error = '';
        this.auth.authenticated(response.data.token);
        this.$store.dispatch('setAuth', true);
        this.user.getUser().then(
          (response) => {
            this.$store.dispatch('setUser', response.data.user).then(
              () => {
                this.$store.dispatch('loadCourse');
              },
            );
            this.$router.push({ name: 'course' });
          },
          (error) => {
            this.errorReport(error);
            this.loadingStatus = true;
          },
        );
      },
      (error) => {
        this.errorReport(error);
        this.loadingStatus = true;
      },
    );
    this.loadingStatus = false;
  }

  errorReport(error) {
    if (error.response){
      if (error.response.data.errors){
        if (error.response.data.errors['email']){
          this.error = error.response.data.error || error.response.data.errors['email'][0]
        } 
        else{
          this.error = error.response.data.error || error.response.data.errors['password'][0]
        }
      }
      else{
        this.error = error.response.data.error;
      }
    }
    else{
      this.error = 'Unable to connect to the server';
    }
  }
}